module.exports = __webpack_public_path__ + "img/tile-med1.3bcfbc94.jpg";